<template>
  <div>
    <vue-advanced-chat
        ref="chatWindow"
        :height="isAndroid ? 'calc(100vh)' : 'calc(100vh - 55px)'"
        :current-user-id="myUser"
        :room-id="roomId"
        :load-first-room="'false'"
        :rooms="JSON.stringify(loadedRooms)"
        :loading-rooms="JSON.stringify(loadingRooms)"
        :rooms-loaded="JSON.stringify(roomsLoaded)"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        :message-selection-actions="JSON.stringify(messageSelectionActions)"
        :text-messages="JSON.stringify(textMessages)"
        :show-audio="'false'"
        :media-preview-enabled="'false'"
        :message-actions="JSON.stringify(messageActions)"
        :show-reaction-emojis="'false'"
        :show-emojis="'false'"
        :show-new-messages-divider="'false'"
        :textarea-auto-focus="'false'"
        :show-add-room="'false'"
        :styles="JSON.stringify(styles)"
        :username-options="JSON.stringify({minUsers: 3, currentUser: false})"
        @fetch-more-rooms="fetchMoreRooms"
        @add-room="onShowCreateRoom"
        @fetch-messages="fetchMessages($event.detail[0])"
    >
      <div slot="spinner-icon-infinite-rooms">
        <div id="vac-circle" v-if="loadingRooms"></div>
      </div>
      <!--div v-for="(message, index) in messages" :slot="'message-avatar_' + message._id"
           :class="[message.senderId !== myUser ? 'chat-avatar' : 'chat-avatar mine']" class="chat-avatar" v-if="index === 0 || messages[index-1].senderId !== message.senderId">
        {{getFistCharacter(message.username)}}
      </div-->
    </vue-advanced-chat>


    <b-modal size="md" v-model="showCreateRoom" centered title="Neuen Chat starten"
    >
      <b-row class="mt-2">
        <b-col>
          <span>Mitarbeiter auswählen</span>
          <v-jstree ref="js_tree" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; margin-top: 0.75rem"
                    class="my-tree" :data="possibleUser"
                    @item-click="onItemClicked"
                    show-checkbox
                    :multiple="true"
                    :allow-batch="true"></v-jstree>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="selectedUser.length > 1">
        <b-col>
          <span>Chatname:</span>
          <b-form-input style="margin-top: 0.75rem" class="form-control text-black"
                        v-model="roomName"
          ></b-form-input>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="onCancelCreateRoom">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!canContinue" variant="success" @click="onCreateRoom">
          Chat starten
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import * as firestoreService from '@/shared/firebase/database'
import {register} from 'vue-advanced-chat'
import {isImageFile, Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import VJstree from "vue-jstree";
import MediaPreview from "../messaging/util/MediaPreview.vue"
import {
  decryptAES,
  decryptChatMessages,
  decryptFile,
  decryptRooms,
  encryptAES,
  encryptEntry,
  encryptFile
} from "@/shared/crypto";
import {formatTimestamp, parseTimestamp} from "@/shared/dates";
import {v4, v4 as uuidv4} from 'uuid';
const messageRefreshRate = 1000;
register()
export default {
  name: "messaging",
  components: {
    VJstree,
    MediaPreview,
  },
  data() {
    return {
      isAndroid: false,
      // util
      loader: undefined,
      // file preview
      previewFile: null,
      showPreview: false,
      // show room users
      showGroup: false,
      roomUsers: [],
      // create room
      showCreateRoom: false,
      possibleUser: [],
      selectedUser: [],
      selectedUserNames: [],
      roomName: "",
      currentNewId: '',
      // chat config
      myUser: "",
      roomsPerPage: 20,
      rooms: [],
      roomId: '',
      roomsLoaded: false,
      loadingRooms: true,
      roomsLoadedCount: 0,
      selectedRoom: null,
      messagesPerPage: 20,
      messages: [],
      messagesLoaded: false,
      menuActions: [
        {name: 'showUsers', title: 'Gruppenmitglieder anzeigen'},
        {name: 'gotoTask', title: 'Zur Aufgabe'},
        {name: 'inviteUser', title: 'Nutzer hinzufügen'},
        {name: 'leaveChat', title: 'Chat verlassen'},

      ],
      messageSelectionActions: [{name: 'newTask', title: 'Neue Aufgabe anlegen'}],
      messageActions: [
        {
          name: 'selectMessages',
          title: 'Markieren'
        },
        {
          name: 'newTaskFromMessage',
          title: 'Neue Aufgabe anlegen'
        },
        {
          name: 'setMessagePriority',
          title: 'Als Prioritaet versenden',
          onlyMe: true
        },
      ],
      styles: {
        message: {
          background: '#fff',
          backgroundMe: '#e8eff8',
        }
      },
      textMessages: {
        ROOMS_EMPTY: 'Sie haben noch keine Chats.',
        ROOM_EMPTY: 'Kein Chat geöffnet',
        NEW_MESSAGES: 'Neue Nachrichten',
        MESSAGE_DELETED: 'Nachricht geloescht',
        MESSAGES_EMPTY: 'Keine Nachrichten im Chat',
        SEARCH: 'Suchen',
        CANCEL_SELECT_MESSAGE: 'Selektion beenden',
        TYPE_MESSAGE: 'Nachricht schreiben',
        CONVERSATION_STARTED: 'Beginn der Konversation: ',
      },
      // timers
      currentUserId: "",
      customerNumber: "",
      lastLoadedMessage: null,
      latestLoadedMessage: null,
      messageListeners: [],
      roomListeners: [],
      // invite users
      showInviteUser: false,
      possibleInvites: [],
      selectedInvite: null,
      showModalMap: false,
    }
  },
  beforeDestroy() {
    this.messageListeners.forEach(listener => listener())
    this.messageListeners = []
    this.roomListeners.forEach(listener => listener())
    this.roomListeners = []
  },
  computed: {
    lastLoadedRoom() {
      if (this.rooms.length) {
        let index = Number.MAX_SAFE_INTEGER;
        let doc = null;
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].index < index) {
            doc = this.rooms[i].doc;
            index = this.rooms[i].index;
          }
        }
        return doc;
      } else {
        return null;
      }
    },
    loadedRooms() {
      return this.rooms.slice(0, this.roomsLoadedCount)
    },
    canContinue() {
      if (this.selectedUser.length === 1) {
        return true;
      } else if (this.selectedUser.length > 1 && this.roomName !== "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    roomId(n, o) {
    }
  },
  mounted() {
    //this.fetchRooms()
    //console.log(this.$refs.chatWindow.shadowRoot.)
    this.isAndroid = navigator.userAgent === "BisOfficeMobile";
    var sheet = new CSSStyleSheet();
    sheet.replaceSync( `.vac-message-wrapper .vac-message-container {
  width: 95% !important;
}

 #vac-icon-double-checkmark-seen {
     fill: #6d6def !important;
  }
  .vac-message-actions-wrapper .vac-menu-left {
      right: 15px !important;
   }
.vac-message-wrapper .vac-message-box{
  width: 100% !important;
  min-width: 100% !important;
}
.vac-message-files-container .vac-file-wrapper .vac-file-container {
    width: auto !important;
    max-width: 150px !important;
  }
  .vac-message-files-container .vac-file-wrapper {
     margin: 0 auto;
  }

.vac-message-wrapper .vac-offset-current {
  margin-left: 0px !important;
}`)
    this.$refs.chatWindow.shadowRoot.adoptedStyleSheets = [ sheet ]
    this.currentUserId = this.$cookies.get("ps_user_id");
    this.customerNumber = this.$cookies.get("ps_customer_number");
    this.myUser = this.currentUserId;
    let roomId = this.$route.query.room_id;
    let isTask = this.$route.query.is_task;
    if (roomId && roomId !== "") {
      this.$router.push("/chats/rooms/" + roomId + "?is_task="+isTask)
      return;
    }
    this.showLoader()
    this.$http.get(
        Server_URL + '/auftragsbuch/messaging/init'
    ).then(this.handleDataInit, this.responseError)
  },
  beforeMount(){
    window['AndroidWebView'] = {
      components:  this,
      onPause: () => this.onPause(),
      onUnpause: () => this.onUnpause(),
    };
  },
  methods: {
    onPause() {
      // todo check for firestore listeners
    },
    onUnpause() {
      // todo check for firestore listeners
    },
    fetchMessages({room, options}) {
      this.roomId = '';
      this.$router.push("/chats/rooms/"+room.roomId);
    },
    getFistCharacter(name) {
      return name.charAt(0).toUpperCase()
    },
    isInRoom(room, userId) {
      let found = false;
      for (let j = 0; j < room.users.length; j++) {
        if (userId === room.users[j]._id || userId === this.myUser) {
          found = true;
          break
        }
      }
      return found;
    },
    getCurrentPossibleSelection(org, room) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = {...org[i]};
        cur.selected = false;
        if (cur.node_type === 'user' && !this.isInRoom(room, cur.id)) {
          res.push(cur)
        } else if(cur.children !== null) {
          cur.children = this.getCurrentPossibleSelection(cur.children, room)
          res.push(cur)
        }
      }
      return res;
    },
    onItemClicked(node, item, e) {
      this.selectedUser = this.getSelectedUsers(this.possibleUser);
      this.selectedUserNames = this.getSelectedNames(this.possibleUser);
    },
    handleDataInit(response) {
      if (response.status === 200) {
        let data = response.body;
        this.possibleUser = this.setNames(data.possible_users);
        this.myUser = data.user_id;
        this.hideLoader();
        this.fetchRooms();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
          }
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    getSelectedUsers(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.id)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedUsers(cur.children))
        }
      }
      return res;
    },
    getSelectedNames(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.text)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedNames(cur.children))
        }
      }
      return res;
    },
    unselectUsers(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          org[i].selected = false;
        }
        if (cur.children !== null && cur.children.length > 0) {
          this.unselectUsers(cur.children)
        }
      }
    },
    onCreateRoom() {
      this.selectedUser.push(this.$cookies.get("ps_user_id"));
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      this.selectedUserNames.push(res.full_name);
      encryptAES(sessionStorage.getItem("aes"), res.full_name + " hat die Gruppe erstellt.").then(enc => {
        let req = {
          room_name: this.roomName,
          participants: this.selectedUser,
          participant_names: this.selectedUserNames,
          initial_message: enc,
        };
        this.showLoader()
        this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room', req
        ).then(this.handleRoomOk, this.responseError)
        this.showCreateRoom = false;
      })
    },
    handleRoomOk(response) {
      if (response.status === 200) {
        this.hideLoader();
        this.$router.push("/chats/rooms/"+room.roomId);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    onShowCreateRoom() {
      this.unselectUsers(this.possibleUser);
      this.selectedUser = [];
      this.selectedUserNames = [];
      this.roomName = "";
      this.showCreateRoom = true;
    },
    onCancelCreateRoom() {
      this.showCreateRoom = false;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    resetRooms() {
      this.loadingRooms = true;
      this.roomsLoadedCount = 0;
      this.rooms = [];
      this.roomsLoaded = false;
      this.roomListeners.forEach(listener => listener());
      this.roomListeners = [];
      this.messageListeners.forEach(listener => listener());
      this.messageListeners = [];
    },
    fetchRooms() {
      this.resetRooms()
      this.fetchMoreRooms(null, true)
    },
    fetchMoreRooms(e, init) {
      if (init) {
       this.listenRooms();
      } else {
        firestoreService.getRooms(this.customerNumber, this.currentUserId, 10, this.lastLoadedRoom)
            .then(({data, docs}) => {
              let changes = [];
              for (let i = 0; i < data.length; i++) {
                let d = { ...data[i],
                  roomId: data[i].id,
                  doc: docs[i]};
                changes.push(d)
              }
              decryptRooms(sessionStorage.getItem("aes"), changes).then(res => {
                this.processRooms(res)
              })
            })
      }
    },
    listenRooms() {
      const listener = firestoreService.listenRooms(
          this.customerNumber,
          this.myUser,
          10,
          (data) => {
            let changes = [];
            let deletions = [];
            for (let i = 0; i < data.length; i++) {
              let d = { ...data[i].doc.data(),
                roomId: data[i].doc.id,
                id: data[i].doc.id,
                doc: data[i].doc};
              if (data[i].type === "removed") {
                deletions.push(d)
              } else {
                changes.push(d)
              }
            }
            for (let i = 0; i < deletions.length; i++) {
                firestoreService.getMessageCounter(this.customerNumber, deletions[i].roomId, this.currentUserId).then((res) => {
                  if (!res.last_active) {
                    // user removed from chat
                    this.removeChat(deletions[i].roomId)
                  }
                }).catch(err => {
                  console.log(err);
                });
            }
            // todo do something with removals
            decryptRooms(sessionStorage.getItem("aes"), changes).then(res => {
              this.processRooms(res, false, true)
            })

          }
      )
      this.roomListeners.push(listener)
    },
    removeChat(roomId) {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          this.rooms.splice(i, 1);
          break
        }
      }
      this.rooms = [...this.rooms]
    },
    getRoomIndex(roomId) {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    async processRooms(data, isNew, fromListener) {
      if (!isNew && !fromListener) {
        this.roomsLoaded = data.length === 0 || data.length < this.roomsPerPage
      }
      let roomId = '';
      if (isNew && data.length === 1) {
        roomId = data[0].roomId;
        this.currentNewId = roomId;
      }
      const roomsToAdd = [];
      for (let i = 0; i < data.length; i++) {
        const room = data[i];
        for (let j = 0; j < room.users.length; j++) {
          let cur = room.users[j];
          let res = JSON.parse(sessionStorage.getItem(cur));
          let real = {
            _id: cur,
            username: '',
          }
          if (res) {
            real.username = res.full_name;
          }
          room.users[j] = real;
        }
        const roomContacts = room.users.filter(
            user => user._id !== this.currentUserId
        )
        room.users.push({
          _id: "dummy",
          username: ''
        })
        if (room.room_type === "chat") {
          room.roomName =
              roomContacts.map(user => user.username).join(', ')
          room.avatar = "/person_test.png"
        } else if (room.room_type === "group") {
          room.avatar = "/group_test.png"
          room.roomName = room.name;
        } else {
          room.avatar = "/assignment_test.png"
          room.roomName = room.name;
        }
        if (room.latest_message) {
          let res = JSON.parse(sessionStorage.getItem(room.latest_message.user_id));
          let lastMessage = {
            content: room.latest_message.content,
            senderId: room.latest_message.user_id,
            username: res && room.latest_message.user_id !== this.myUser ? res.full_name : '',
            timestamp: formatTimestamp(
                new Date(Date.parse(room.latest_message.create_date.toDate())),
                new Date(Date.parse(room.latest_message.create_date.toDate()))
            )
          }
          room.lastMessage = lastMessage;
        }
        if (isNew) {
          // keep the new room at top until it is re-fetched or the user selects another room
          room.isNew = true;
          room.index = Number.MAX_SAFE_INTEGER;
        } else {
            try {
              let res = await firestoreService.getMessageCounter(this.customerNumber, room.roomId, this.currentUserId);
              room.unreadCount = res.count_unread;
            } catch (e) {
              console.log(e)
            }
          room.index = room.update_date.toDate().getTime();
        }
        let roomIndex = this.getRoomIndex(room.roomId);
        if (roomIndex !== -1) {
          this.rooms[roomIndex] = room;
          this.rooms = [...this.rooms]
        } else {
          roomsToAdd.push(room);
        }
      }

      this.rooms = this.rooms.concat(roomsToAdd)
      if (!this.rooms.length) {
        this.roomsLoadedCount = 0
      } else {
        this.roomsLoadedCount = this.rooms.length
      }
      this.loadingRooms = false
      if (roomId !== '') {
        this.$nextTick(() => {
          this.roomId = roomId.toString();
        });
      }
    },
  }
}
</script>

<style>
form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.tree-default .tree-disabled > .tree-checkbox {
  display: none;
}

.tree-default .tree-disabled {
  color: inherit !important;
}

</style>

<style scoped>
#vac-circle {
  height: 20px;
  width: 20px;
}

#vac-circle {
  margin: auto;
  height: 28px;
  width: 28px;
  border: 3px rgba(0, 0, 0, .25) solid;
  border-top: 3px #333 solid;
  border-right: 3px #333 solid;
  border-bottom: 3px #333 solid;
  border-radius: 50%;
  -webkit-animation: vac-spin 1s infinite linear;
  animation: vac-spin 1s infinite linear;
}

@keyframes vac-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

.chat-avatar {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  font-size: 18px;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgb(0, 0, 0);
  margin-top: 5px;
  margin-left: 4px;
}

.chat-avatar.mine {
  background: rgb(203, 33, 33);
}

</style>

<style>
.vac-message-wrapper .vac-message-container {
  width: 90% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 90% !important;
  min-width: 90% !important;
}

.vac-message-wrapper .vac-message-container {
  margin-left: 10% !important;
}
</style>
